import ButtonDialog from "#common/Dialog/ButtonsDialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import PERMISOS from "#constants/perfiles"
import { COLOR_PRIMARY } from "#constants/Styles"
import { DialogMaster } from "#core/components/dialog/Dialog"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import { useRefresh } from "#vacancy/redux/actions"
import { vacancyAuthGet, vacancyAuthIdPut } from "#vacancy/services/api"
import CancelIcon from "@mui/icons-material/Cancel"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import {
	Card,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Stack,
	Typography,
} from "@mui/material"
import Button from "@mui/material/Button"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import { reloadDataVacante } from "app/pageSlice"
import { useColaboradorId } from "app/userSlice"
import { Fragment, useMemo, useState } from "react"
import { useDispatch } from "react-redux"

function VacancyAuth({ profileData, open }) {
	const params = useMemo(() => ({ id: profileData.id }), [profileData.id])
	const { data, loading, error } = useApi(vacancyAuthGet, { params, autoFetch: open })
	const auths = data?.data

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />
	return (
		<Stack spacing={3} direction={"row"} justifyContent={"center"}>
			{auths?.map((auth) => {
				return <VacancyAuthCard data={auth} />
			})}
		</Stack>
	)
}
export default function VacancyAuthDialog({ profileData, open, setOpen }) {
	return (
		<DialogMaster {...{ open, setOpen, title: "VOBO'S", maxWidth: "xl" }}>
			<VacancyAuth profileData={profileData} open={open} />
		</DialogMaster>
	)
}

const VacancyAuthCard = ({ data }) => {
	let info = {}
	const isRh = UseHasPermission(PERMISOS.RH)
	const colaboradorId = useColaboradorId()

	switch (data?.is_authorized) {
		case true:
			info.icon = <CheckCircleIcon color={"success"} />
			info.text = "Autorizado"

			break
		case false:
			info.icon = <CancelIcon color={"error"} />
			info.text = "Rechazado"
			break

		default:
			info.icon = null
			info.text = "Dar Autorización"

			break
	}
	const autoriza =
		data?.is_authorized === null && (isRh || colaboradorId === data?.authorization)

	return (
		<Card variant="elevation" sx={{ width: "300px" }}>
			<CardContent>
				<Typography
					variant="h7"
					component="div"
					sx={{
						color: COLOR_PRIMARY,
						textAlign: "center",
						fontWeight: "bold",
					}}
				>
					{data?.authorization_name}
				</Typography>
				<Typography
					variant="subtitle2"
					color="text.secondary"
					sx={{
						textAlign: "center",
					}}
				>
					{data?.authorized_at || ""}
				</Typography>
				<Stack
					direction="column"
					spacing={2}
					alignItems="center"
					justifyContent="center" // 👈 centra horizontalmente
					width="100%" // 👈 importante para que el centrado funcione
				>
					<Typography
						variant="subtitle2"
						color="text.secondary"
						sx={{
							textAlign: "center",
						}}
					>
						{info?.text}
					</Typography>
					{info?.icon}
				</Stack>
			</CardContent>
			{autoriza && (
				<CardActions>
					<Stack
						direction="row"
						spacing={2}
						alignItems="center"
						justifyContent="center" // 👈 centra horizontalmente
						width="100%" // 👈 importante para que el centrado funcione
					>
						<VacancyAuthCardConfirm auth={data} approved={false} />
						<VacancyAuthCardConfirm auth={data} approved={true} />
					</Stack>
				</CardActions>
			)}
		</Card>
	)
}

const VacancyAuthCardConfirm = ({ auth, approved }) => {
	const [btnDisabled, setBtnDisabled] = useState(false)
	const [open, setOpen] = useState(false)
	const dispatch = useDispatch()
	const { refresh } = useRefresh()

	const success = () => {
		refresh()
		dispatch(reloadDataVacante())
		closeDialog()
	}
	const end = () => {
		setBtnDisabled(false)
	}
	const { fetch } = useApiSend(vacancyAuthIdPut, { success, end })

	const closeDialog = () => {
		setOpen(false)
	}
	const mensaje = approved
		? "¿Esta seguro que desea dar VoBo a esta vacante?"
		: "¿Esta seguro que desea rechazar a esta vacante?"
	const autorizar = () => {
		setBtnDisabled(true)
		fetch(auth.vacante, auth.id, { is_authorized: approved })
	}

	return (
		<Fragment>
			<Button size="small" onClick={() => setOpen(true)}>
				{approved ? "Aceptar" : "Rechazar"}
			</Button>
			<Dialog open={open} onClose={closeDialog}>
				<DialogTitle> {"Confirmación"} </DialogTitle>
				<DialogContent>
					<DialogContentText>{mensaje}</DialogContentText>
				</DialogContent>
				<DialogActions sx={{ alignContent: "center", justifyContent: "center" }}>
					<Stack direction={"row"} spacing={3}>
						<ButtonDialog
							disabled={btnDisabled}
							label={"Cancelar"}
							onClick={closeDialog}
						/>

						<ButtonDialog
							disabled={btnDisabled}
							onClick={autorizar}
							autoFocus
							label={"Aceptar"}
						/>
					</Stack>
				</DialogActions>
			</Dialog>
		</Fragment>
	)
}
